import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { equals } from 'ramda';
import { Box } from '@material-ui/core';
import useStyles from './useStyles';

const progressBar = props => {
  const classes = useStyles();
  const { totalCount, currentProress } = props;

  if (totalCount === 1) return null;
  const marks = [...new Array(totalCount).keys()];

  return (
    <Box className={classes.container}>
      {marks.map(index => {
        const currentProressIndex = currentProress - 1;
        const isHighlited = equals(currentProressIndex, index);
        return <Box key={index} className={clsx(classes.mark, { [classes.active]: isHighlited })} />;
      })}
    </Box>
  );
};

progressBar.propTypes = {
  totalCount: PropTypes.number,
  currentProress: PropTypes.number,
};

progressBar.defaultProps = {
  totalCount: 1,
  currentProress: 1,
};

export default progressBar;



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/ProgressBar/ProgressBar.js